import { fadeEasingFunction } from '../../utils/fade-easing';

export const calculateFadeInOpacity = ({
  currentFrame,
  fadeInDurationInSeconds,
  framesPerSecond,
  fadeWindow,
}: {
  currentFrame: number;
  fadeInDurationInSeconds: number;
  framesPerSecond: number;
  fadeWindow?: {startInSeconds:number;endInSeconds:number};
}): number => {
  if (fadeInDurationInSeconds === 0) {
    return 1;
  }
  const progress = Math.min(
    1,
    Math.max(0,(currentFrame-(fadeWindow?.startInSeconds??0)*framesPerSecond) / (fadeInDurationInSeconds * framesPerSecond)),
  );
  return fadeEasingFunction(progress);
};

export const calculateFadeOutOpacity = ({
  currentFrame,
  fadeOutDurationInSeconds,
  framesPerSecond,
  totalDurationInFrames,
  fadeWindow,
}: {
  currentFrame: number;
  fadeOutDurationInSeconds: number;
  framesPerSecond: number;
  totalDurationInFrames: number;
  fadeWindow?: {startInSeconds:number;endInSeconds:number};
}): number => {
  if (fadeOutDurationInSeconds === 0) {
    return 1;
  }
  const fadeOutStartFrame =
    (fadeWindow?fadeWindow.endInSeconds*framesPerSecond:totalDurationInFrames) - fadeOutDurationInSeconds * framesPerSecond;
  const progress = Math.max(
    0,
    1 -
      (currentFrame - fadeOutStartFrame) /
        (fadeOutDurationInSeconds * framesPerSecond),
  );
  return fadeEasingFunction(progress);
};
